import { render, staticRenderFns } from "./ed-table-modal.vue?vue&type=template&id=a5d87d76&"
import script from "./ed-table-modal.ts?vue&type=script&lang=ts&"
export * from "./ed-table-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports